/**
 * weirwood的配置文件
 */

const ignoreUrls = [
// 本地开发屏蔽错误发送
'localhost', '127.0.0.1', 'http://dzy.baidu.com:8080'];
export default {
  // 通用选项
  common: {
    buildid: '839',
    token: '1071cff17fca4c88a5d846a6b600e2ad',
    ignoreUrls
  },
  // 错误监控选项，优先级高于通用参数配置
  error: {
    collectWindowErrors: true,
    // promise异常
    collectUnhandledRejections: true,
    // 静态资源加载异常
    collectResourceLoadErrors: false,
    // 是否自动收集后端API异常
    collectAutoAPIException: false,
    ignoreUrls
  },
  // 性能监控选项，优先级高于通用参数配置
  perf: {
    // 性能数据PV日志会比较大，可以输入 sampleRate 进行采样，控制在 50 W左右
    sampleRate: 0,
    disable: true,
    spa: true,
    history: true,
    ignoreUrls
  }
};